import { Heading, StackDivider, VStack, Text, HStack } from '@chakra-ui/react';
import React from 'react';
import Emoji, { EmojiProps } from './Emoji';

type PageHeaderProps = {
  title: string;
  subtitle?: string;
  emoji?: EmojiProps;
};

export const PageHeader = (props: PageHeaderProps) => (
  <VStack w={['xs', 'md', 'lg']} align="flex-start" spacing={2}>
    <HStack>
      {props.emoji && <Emoji header {...props.emoji} />}
      <Heading fontSize={['2xl', '3xl', '4xl']}>{props.title}</Heading>
    </HStack>
    <StackDivider borderColor="purple.200" borderWidth={1} />
    {props.subtitle && (
      <Text as="p">
        <em>{props.subtitle}</em>
      </Text>
    )}
  </VStack>
);
